var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { format, isValid, parse } from 'date-fns';
import { StateContext, DispatchContext } from './DatePickerContext';
import * as actionTypes from '../reducer/actionTypes';
import DatePickerDescription from './DatePickerDescription';
import { isEqualDate } from '../helpers/date';
import { isFunction } from '../helpers/function';
import { useDebounce, useUpdateEffect } from '../helpers/hooks';
import { SCREEN_READER_MESSAGE_ID } from '../constants';
var DatePickerInput = function (_a) {
    var _b = _a.dateFormat, dateFormat = _b === void 0 ? 'dd/MM/yyyy' : _b, screenReaderMessage = _a.screenReaderMessage, props = __rest(_a, ["dateFormat", "screenReaderMessage"]);
    var dispatch = React.useContext(DispatchContext);
    var _c = React.useContext(StateContext), selectedDate = _c.selectedDate, showCalendar = _c.showCalendar, locale = _c.locale, inputRef = _c.inputRef;
    var _d = React.useState(props.placeholder ? '' : format(selectedDate, dateFormat, { locale: locale })), value = _d[0], setValue = _d[1];
    var debouncedValue = useDebounce(value, 500);
    useUpdateEffect(function () {
        var newSelectedDate = parse(debouncedValue, dateFormat, new Date());
        if (isEqualDate(newSelectedDate, selectedDate) ||
            !isValid(newSelectedDate)) {
            return;
        }
        dispatch({
            type: actionTypes.SET_SELECTED_DATE,
            payload: newSelectedDate
        });
    }, [debouncedValue]);
    useUpdateEffect(function () {
        setValue(format(selectedDate, dateFormat, { locale: locale }));
    }, [selectedDate]);
    var userOnChange = props.onChange, rest = __rest(props, ["onChange"]);
    var onChange = function (event) {
        if (isFunction(userOnChange)) {
            userOnChange(event);
        }
        setValue(event.target.value);
    };
    var onFocus = function () {
        dispatch({ type: actionTypes.PREVENT_CELL_FOCUS });
        if (!showCalendar) {
            dispatch({ type: actionTypes.SHOW_CALENDAR });
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("input", __assign({ ref: inputRef, type: 'text', value: value, onChange: onChange, onFocus: onFocus, "aria-describedby": SCREEN_READER_MESSAGE_ID }, rest)),
        React.createElement(DatePickerDescription, { message: screenReaderMessage && isFunction(screenReaderMessage)
                ? screenReaderMessage()
                : screenReaderMessage })));
};
export default DatePickerInput;
